import styled from 'styled-components';
import device from '../mediaQueries';

const BackToTopButtonWrapper = styled.div`
  background: #fff;
  ${props => (props.path ? `background-image: url(${props.path});` : null)}
  background-position: center;
  background-repeat: no-repeat;
  background-size: 30px, 30px;
  border: 1px solid #eee;
  border-radius: 50%;
  border-right: 0;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
  height: 50px;
  opacity: 0.95;
  position: fixed;
  right: 10px;
  width: 50px;
  z-index: 1;
  ${device.desktop`
    bottom: 50px; 
  `}
  ${device.mobile`
    bottom: 10px; 
  `}
`;

export { BackToTopButtonWrapper };
